<div class="w-full flex justify-evenly items-center gap-1">
	<app-counter
		*ngFor="let item of rows; let i = index; trackBy: trackByIndex"
		[rowName]="item.rowName"
		[options]="item.options"
		[counter]="counters[item.rowName]"
		(counterChange)="valueChange($event, item)"
	>
	</app-counter>
</div>
